import React from 'react';
import { View } from 'react-native';
import i18n from 'i18n-js';

import { scale as initialScale, role } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import { LEVELS, isPhone, LEVELS_WITH_FLAGS, withERP } from '@helpers';
import LevelSelector from '@styles/selectors/level';
import { connect } from 'react-redux';
import { isRestrictedForOperator, RESTRICTION_CATEGORIES } from '@config/operatorRestrictions';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

const LevelComponent = ({
  C,
  level,
  changeLevel,
  changeFilter,
  filter,
  featureFlags,
  width,
  isWithERP,
  attachMode,
  isPopupMode,
  scale = initialScale,
  font = initialFont,
}) => {
  const storage = {
    [LEVELS.ALL]: LEVELS,
    [LEVELS.Parts]: null,
    [LEVELS.Operations]: null,
    [LEVELS.ProductionBatches]: null,
    [LEVELS.ProductionOrders]: null,
    [LEVELS.NCFiles]: null,
    [LEVELS.Tools]: null,
    [LEVELS.Machines]: null,
    [LEVELS.Persons]: null,
  };

  const isWithERPValue = withERP(isWithERP);
  const omitLevelsWithoutERP = [LEVELS.Operations, LEVELS.ProductionOrders];

  // if (FeatureFlagsAvailable('search-image-documents', featureFlags)) {
  //   storage[LEVELS.ImagesDocuments] = IMAGE_DOCUMENTS_LEVELS;
  // } else {
  //   delete storage[LEVELS.ALL].ImagesDocuments;
  // }

  const currentLevel = storage[level];

  const tabs = Object.values(LEVELS_WITH_FLAGS || {})
    .map((obj) => {
      // Exclude Machines and Persons when not in attachment mode
      if (!attachMode && [LEVELS.Machines, LEVELS.Persons].includes(obj.key)) {
        return null;
      }

      // Exclude Tools, Images & Documents, and Batches when in attachment mode
      if (attachMode && [LEVELS.Tools, LEVELS.ImagesDocuments, LEVELS.ProductionBatches].includes(obj.key)) {
        return null;
      }

      // Exclude restricted levels for operators
      if (isRestrictedForOperator(role || '', RESTRICTION_CATEGORIES.SEARCH_LEVELS, obj.key)) {
        return null;
      }

      return !isWithERPValue && omitLevelsWithoutERP.includes(obj.key)
        ? null
        : {
            name: i18n.t(obj.name),
            key: obj.key,
            buttonText: i18n.t(obj.name),
            flag: obj.flag,
            testID: `${TEST_IDS.searchScreen.levelSelector}-${obj.key}`,
          };
    })
    .filter(Boolean);

  const levelTabs = Object.values(currentLevel || {})
    .map((key) => {
      return !isWithERPValue && omitLevelsWithoutERP.includes(key)
        ? null
        : {
            name: i18n.t(key),
            key,
            buttonText: i18n.t(key),
          };
    })
    .filter(Boolean);

  const base = {
    isPhone: true,
    itemBG: 'Filter/Light/Unselected',
    selectedItemBG: 'Filter/Light/Selected',
    color: 'Filter/Light/Unselected Text',
    selectedColor: 'Filter/Light/Selected Text',
    blur: isPhone,
    alignLeft: true,
    itemFont: 'Button 2',
    itemStyle: {
      paddingVertical: scale(8),
      paddingHorizontal: scale(12),
      borderRadius: scale(10),
      marginRight: scale(8),
      borderColor: C('Fill/Light/Secondary'),
      borderWidth: scale(1),
    },
    scale,
    font,
  };

  return (
    <View style={{ marginBottom: scale(20), width }}>
      {isPhone ? (
        level === LEVELS.ALL || !currentLevel ? (
          <LevelSelector
            key={'all'}
            {...{
              selectedLevel: level,
              setSelectedLevel: changeLevel,
              tabs,
              ...base,
              isPopupMode,
            }}
          />
        ) : (
          <LevelSelector
            {...{
              selectedLevel: filter,
              setSelectedLevel: changeFilter,
              tabs: levelTabs,
              preventRef: true,
              ...base,
              isPopupMode,
            }}
          />
        )
      ) : (
        <View style={{ flexDirection: 'row' }}>
          <View>
            <LevelSelector
              key={'all'}
              {...{
                selectedLevel: level,
                setSelectedLevel: changeLevel,
                tabs,
                ...base,
                isPopupMode,
              }}
            />
          </View>
          <View style={{ marginLeft: scale(26) }}>
            {level !== LEVELS.ALL && currentLevel && (
              <LevelSelector
                {...{
                  selectedLevel: filter,
                  setSelectedLevel: changeFilter,
                  tabs: levelTabs,
                  preventRef: true,
                  ...base,
                  isPopupMode,
                }}
              />
            )}
          </View>
        </View>
      )}
    </View>
  );
};

export default connect(({ membership: { isWithERP } }) => ({ isWithERP }), {})(LevelComponent);
